/** Kinora Guild app URL for cross-app CTAs (P1-8, P2-5). */
export { GUILD_URL } from './appUrls.js';
import { GUILD_URL } from './appUrls.js';

export function guildAuthUrl() {
  return `${GUILD_URL}/auth`;
}

export function guildRolesUrl() {
  return `${GUILD_URL}/roles`;
}
